import commonActions from '@/store/data/common/actions'
import { webRequestClient } from '@/services'
import { get, toNumber, isEmpty } from 'lodash'
import { errorHandler } from '@/utils/helpers'

const actions = {
    /**
     * Retrieves shared audiences. set them in state.list with previously retrieved shared audiences
     * @param {string} audienceId id of the audience to be retrieved
     */
    retrieveSharedAudiences({ commit, state, rootState }, params) {
        const _params = {
            params: {
                audience_id: toNumber(params.audienceId),
                product_account_id: toNumber(rootState.account.accountId)
            }
        }
        commit('setIsLoading', true)
        return webRequestClient
            .get('/audience_admin/audiences/sharing_accounts/json', _params)
            .then(response => {
                if (get(response, 'status', '') === 'KO' || isEmpty(response)) {
                    errorHandler('Error while retrieving sharing accounts of the audience', commit)
                } else {
                    return commit('setSharedAudiences', { items: { ...state.list, [params.audienceId]: response.list } })
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    },

    /**
     * Stops the sharing of an audience between 2 accounts
     * @param {string} audienceId id of the audience to be retrieved
     * @param {string} partnerAccountId id of the partner to stop the sharing with
     */
    stopSharedAudience({ commit }, params) {
        const _params = {
            params: {
                audience_id: toNumber(params.audienceId),
                partner_account_id: toNumber(params.partnerAccountId)
            }
        }
        commit('setIsProcessing', { isProcessing: true })
        return webRequestClient
            .delete('/audience_admin/audiences/shared_audience/json', _params)
            .then(response => {
                if (get(response, 'status', '') === 'KO' || isEmpty(response)) {
                    errorHandler('Error while stopping shared audience', commit)
                } else {
                    commit(
                        'notifications/setAddedNotification',
                        { type: 'success', message: 'Sharing with account ' + params.partnerAccountId + ' has been stopped' },
                        { root: true }
                    )
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsProcessing', { isProcessing: false })
            })
    },

    /**
     * Creates a sharing of an audience between 2 accounts
     * @param {string} audienceId id of the audience to be retrieved
     * @param {string} partnerAccountId id of the partner to stop the sharing with
     */
    createSharedAudience({ commit }, params) {
        const _params = {
            audience_id: toNumber(params.audienceId),
            partner_account_id: toNumber(params.partnerAccountId)
        }
        commit('setIsProcessing', { isProcessing: true })
        return webRequestClient
            .post('/audience_admin/audiences/shared_audience/json', _params)
            .then(response => {
                if (get(response, 'status', '') === 'KO' || isEmpty(response)) {
                    errorHandler('Error while creating shared audience', commit)
                } else {
                    commit('setSharedAccountStatus', { audienceId: toNumber(params.audienceId), sharedAccountId: toNumber(params.partnerAccountId) })
                    commit(
                        'notifications/setAddedNotification',
                        {
                            type: 'success',
                            message: 'Audience ' + params.audienceId + ' successfully shared with account ' + params.partnerAccountId
                        },
                        { root: true }
                    )
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsProcessing', { isProcessing: false })
            })
    }
}

export default { ...commonActions, ...actions }
